// Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthContext'; // Importa il hook useAuth
import './Header.css';

const Header = () => {
  const { jwtToken,userRoles,  logout } = useAuth();

  const hasRole = (role) => {
    
    return userRoles && userRoles.includes(role);
  };
  return (
    <nav className={'header-nav'}>
      <img src='/logo.png' alt="Logo" style={{ width: '50px', height: '50px', marginRight: '10px' }} />
      {jwtToken ? (
        <ul>
         
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/crea">Inserisci offerta</Link>
          </li>
          <li>
            <Link to="/about">Statistiche</Link>
          </li>
          
          {hasRole('ROLE_ADMIN') && (
            <li>
              <Link to="/creaUtente">Crea Utente</Link>
            </li>
          )}
            {hasRole('ROLE_ADMIN') && (
            <li>
              <Link to="/listaUtenti">Lista Utenti</Link>
            </li>
          )}
           {hasRole('ROLE_ADMIN') && (
            <li>
              <Link to="/listaUtenti">Crea pacchetto</Link>
            </li>
          )}
          {hasRole('ROLE_ADMIN') && (
            <li>
              <Link to="/categorie">Gestione categorie</Link>
            </li>
          )}
          {hasRole('ROLE_ADMIN') && (
            <li>
              <Link to="/lingue">Gestione lingue</Link>
            </li>
          )}
          
          <li>
            <Link to="/events">Gestisci offerte</Link>
          </li>
          <li>
            <Link to="/profile">Gestisci profilo</Link>
          </li>
          <li>
            <Link to="/about">Chi siamo</Link>
          </li>
         
            <li>
            <button onClick={logout}>Logout</button>
          </li>
        </ul>
      ) : (
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/login">Login</Link>
          </li>
        </ul>
      )}
    </nav>
  );
};

export default Header;
